export const closeAllTabs = (currentLink = null) => {
  const links = document.querySelector('sb-sidenav')?.shadowRoot.querySelectorAll('sb-sidenav-link[variation="parent"]');

  if (links) {
    links.forEach((l) => {
      if (l.shadowRoot.querySelector('.sb-sidenav-link--active') && l !== currentLink) {
        l.changeExpanded();
      }
    });
  }
};
